import { useContext, useEffect, useState } from "react";


// components importation
import { ReloadComp } from "../../components/login-component/ReloadComp";
import { ForgotPassW } from "../../components/home/ForgotPassW.jsx";
import { FaceBook, Instagram, Linkedin, Youtube } from "../../components/icons/AppIcons.jsx";


// app config import
import { LANGUAGE, NAME_LAST_LOC } from "../../config/appConf.js";


// ----> IMAGE IMPORTATIONS
import isotipo from "../../assets/isotipo.png";
import sloganEn from "../../assets/slogan-en.png";
import sloganEs from "../../assets/slogan-es.png";

// ----> REACT ROUTER DOM IMPORTATION
import { Link, useNavigate } from "react-router-dom";

// ----> URLS API IMPORTATION
import { urls } from "../../api-urls/api-urls.js";

// ----> CONTEXT IMPORTATION
import { UserContext } from "../../context/UserContext.jsx";

// notification context
import { NotificationContext } from "../../context/NotificationContext.jsx";

// import lang context
import { LangContext } from "../../context/LangContext.jsx";

// ----> TRANSLATION IMPORTATION
import { useTranslation } from "react-i18next";


import { UrlClient } from "../../components/constants/constants.js"








// ----> ESTE COMPONENTE ES PUBLICO
export const HomeView = () => {

  // GET the react translation
  const [t] = useTranslation("global");

  // GET the useNavigate
  const navigate = useNavigate();

  // notification context
  const { handleNotify } = useContext(NotificationContext);

  // GET lang context
  const { lang } = useContext(LangContext);

  // ----> STATE LOGIN
  const [loginState, setLoginState] = useState({ userName: "", userPassw: "" });
  const [errorsLogin, setErrorsLogin] = useState({ userName: false, userPassw: false });
  const [forgot, setForgot] = useState(false);
  const [modalReload, setModalReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // ----> USE CONTEXT
  const { setUserContext } = useContext(UserContext);


  // funcion para cerrar forgot passwd
  const onHandleCloseForgot = () => {
    setForgot(false);
  };


  // funcion para obtener la version de la app
  const onGetVersion = async () => {
    const END_POINT = `${urls.authRoute}/version`;
    try {
      const response = await fetch(END_POINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });

      const data = await response.json();

      if (response.status === 200) {

        const VER_LOCAL_S = localStorage.getItem("x-app-cus-v");

        if (VER_LOCAL_S) {
          if (VER_LOCAL_S !== data?.ver) {
            setModalReload(true);
            localStorage.setItem("x-app-cus-v", data?.ver);
          }
        } else {
          localStorage.setItem("x-app-cus-v", data?.ver);
        }

      }

    } catch (err) {
      console.log(err);
    }
  };


  // ----> HANDLE SUBMIT
  const handleSubmit = async (event) => {
    event.preventDefault();

    const patron = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // VALIDAR QUE EL CORREO SEA CORRECTO

    // VALIDAR QUE EL USUARIO NO ENVIE INFORMACION VACIA 
    if (!loginState.userName && !loginState.userPassw) {
      setErrorsLogin({ userName: true, userPassw: true })
      return handleNotify(true, t("HomeViewComp.msgPassAndUserEmpty"), true);

    } else if (!patron.test(loginState.userName)) {
      setErrorsLogin({ userName: true, userPassw: false });
      return handleNotify(true, t("HomeViewComp.invalidEmail"), true);

    } else if (loginState.userPassw.trim() === "") {
      setErrorsLogin((val) => ({ ...val, userPassw: true }));
      return handleNotify(true, t("HomeViewComp.passwordAlert"), true);

    } else if (loginState.userName.trim() === "") {
      setErrorsLogin((val) => ({ ...val, userName: true }));
      return handleNotify(true, t("HomeViewComp.userNameAlert"), true);
    }

    const tkn = localStorage.getItem("prevLoc");

    let idEqp = "";

    if (tkn && (tkn.includes("id_equip") || tkn.includes("id-equip"))) {
      idEqp = tkn.split("=")[1];
    }

    const END_POINT = `${urls.authRoute}?language=${LANGUAGE}&id_equip=${idEqp}&urlC=${UrlClient}`;

    try {

      setIsLoading(true);
      const response = await fetch(END_POINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(loginState)
      });

      console.clear();

      const data = await response.json();

      if (response.status === 200) {
        // sessionStorage.setItem("userName", data?.nombre);
        // sessionStorage.setItem("userInfo", JSON.stringify(data));
        setUserContext(data);
        localStorage.setItem("token", data?.token);

        const LAST_LOCAT = localStorage.getItem("prevLoc");
        if (LAST_LOCAT !== null) {
          return navigate(LAST_LOCAT);
        }
        // console.log(data)
        navigate("/create-case");
      } else if (response.status === 404) {
        setErrorsLogin({ userName: true, userPassw: true })
        handleNotify(true, t("HomeViewComp.invalidEmailPassWordBackend"), true);
        // console.log('Al parecer usted no está registrado en nuestro sistema');
      } else if (response.status === 401) {
        setErrorsLogin({ userName: true, userPassw: true });
        handleNotify(true, t("HomeViewComp.invalidEmailPassWordBackend"), true);
      }

      setIsLoading(false);

    } catch (error) {
      handleNotify(true, t("HomeViewComp.connectionRefuse"), true);
      setErrorsLogin({ userName: false, userPassw: false });
      // console.log(error)
    }

  };

  // SET THE DOCUMENT TITLE
  useEffect(() => {
    document.title = LANGUAGE === "es" ? "App Cliente" : "Client App";
  }, []);


  // useEffect para obtener la version
  useEffect(() => {

    onGetVersion();

    document.title = LANGUAGE === "en" ? "Global Medica Customer Portal" : "Global Medica Portal Clientes";

  }, []);



  return (
    <>
      {
        // reload componente
        modalReload && (<ReloadComp />)
      }
      {
        // forgot component
        forgot && (<ForgotPassW onClose={onHandleCloseForgot} />)
      }
      <div className="container-home fade-animation"> {/* CONTAINER */}
        {/* DIV LATERAL IZQUIERDO */}
        {
          window.screen.width >= 1280 && (
            <div className="hero-left">

            </div>
          )
        }
        {/* DIV LATERAL DERECHO */}
        <div className="hero-right">
          <div className="isotipo-container">
            <img className="isotipo" src={isotipo} alt="Isotipo Global" />
          </div>
          <div className="login">
            {/* LABEL E INPUT PARA EL USER */}
            <form onSubmit={handleSubmit}>
              <div className="row-flex">
                <p style={{ padding: 0 }}>
                  <strong style={{ color: 'var(--first-color)' }}>{t("HomeViewComp.usuario")}</strong>
                </p>
              </div>
              <div>
                <input
                  className={errorsLogin.userName ? "invalid-input" : "input-control-text"}
                  type="text"
                  name="email"
                  placeholder="example@example.com"
                  value={loginState.userName}
                  onChange={({ target }) => setLoginState((val) => ({ ...val, userName: target.value.toLowerCase().trim() }))} />
              </div>
              {/* LABEL E INPUT PARA EL PASSWORD */}
              <div className="row-flex j-content-s-b m-top-passw-lbel">
                <p style={{ padding: 0 }}>
                  <strong style={{ color: 'var(--first-color)' }}>{t("HomeViewComp.contrase")}</strong>
                </p>
                <button type="button" className="btn-link-tag" style={{ textDecoration: "none" }} onClick={() => setForgot(true)}>
                  <strong className="label-pwd">{t("HomeViewComp.olvidaste_pwd")}</strong>
                </button>
              </div>
              <div>
                <input
                  className={errorsLogin.userPassw ? "invalid-input" : "input-control-text"}
                  type="password"
                  name="password"
                  placeholder={t("HomeViewComp.ingrese_contra")}
                  value={loginState.userPassw}
                  onChange={({ target }) => setLoginState((val) => ({ ...val, userPassw: target.value }))}
                  autoComplete="off" />
              </div>
              <div className="row-flex flex-end" style={{ marginTop: "0.3rem" }}>
                <Link className="link-tag" to="/sign-up">{t("HomeViewComp.crear_cuenta")}</Link>
              </div>
              <div style={{ margin: "0.8rem 0", textAlign: "center" }}>
                {
                  isLoading ? (
                    <div className="spinner-hed">
                    </div>
                  )
                    :
                    (
                      <button type="submit" className="btn-login">
                        {t("HomeViewComp.iniciar_sesion")}
                      </button>
                    )
                }
              </div>
            </form>
            {/* SLOGAN */}
            <div className="container-slogan" style={{ display: 'flex', justifyContent: 'center' }}>
              {
                lang === "es" ? (<img style={{ opacity: '0.7' }} className="slogan" src={sloganEs} alt="Slogan Es" />) : (<img style={{ opacity: '0.7' }} className="slogan" src={sloganEn} alt="Slogan En" />)
              }
            </div>
            {/* REDES SOCIALES */}
            <div className="social-media-parent">
              {/* INSTAGRAM LOGO */}
              <div className="container-social-media">
                <a href="https://www.instagram.com/globalmedica/?igshid=NTc4MTIwNjQ2YQ" target="_blank" rel="noopener noreferrer">
                  <Instagram />
                </a>
              </div>
              {/* FACEBOOK LOGO */}
              <div className="container-social-media">
                <a href="https://www.facebook.com/gmglobalmedica" target="_blank" rel="noopener noreferrer">
                  <FaceBook />
                </a>
              </div>
              {/* LINKEDIN */}
              <div className="container-social-media">
                <a href="https://www.linkedin.com/company/global-m%C3%A9dica/" target="_blank" rel="noopener noreferrer">
                  <Linkedin />
                </a>
              </div>
              {/* YOUTUBE */}
              <div className="container-social-media">
                <a href="https://www.youtube.com/channel/UCWT2KUVVms56vwB0N9r8qKQ" target="_blank" rel="noopener noreferrer">
                  <Youtube />
                </a>
              </div>
            </div>
          </div>
        </div >
      </div >
    </>
  );
};